import {createStore, StoreApi} from 'zustand'
import {createGameGeneralSlice, GameGeneralSlice, GameGeneralSliceProps} from './slices/gameGeneralSlice'
import {createGameVoteSlice, GameVoteSlice, GameVoteSliceProps} from './slices/gameVoteSlice'
import {createGameTradeSlice, GameTradeSlice, GameTradeSliceProps} from './slices/gameTradeSlice'
import {createGameSettingsSlice, GameSettingsSlice, GameSettingsSliceProps} from './slices/gameSettingsSlice'
import {createGameModeSlice, GameModeSlice, GameModeSliceProps} from './slices/gameModeSlice'
import {createGameStateSlice, GameStateSlice, GameStateSliceProps} from './slices/gameStateSlice'
import {createGameUserStatesSlice, GameUserStatesSlice, GameUserStatesSliceProps} from './slices/gameUserStatesSlice'
import {createGameDetailsSlice, GameDetailsSlice, GameDetailsSliceProps} from './slices/gameDetailsSlice'
import {createGameUserSettingsSlice, GameUserSettingsProps, GameUserSettingsSlice} from './slices/gameUserSettingsSlice'
import {createGameActionBoxSlice, GameActionBoxSlice} from './slices/gameActionBoxSlice'
import {createGameReplaySlice, GameReplaySlice, GameReplaySliceProps} from './slices/gameReplaySlice'
import {createGameEndSlice, GameEndSlice} from './slices/gameEndSlice'
import {createGameBeginnerHintSlice, GameBeginnerHintSlice} from './slices/gameBeginnerHintSlice'
import {createGamePauseSlice, GamePauseSlice, GamePauseSliceProps} from './slices/gamePauseSlice'
import {createGameActionButtonsSlice, GameActionButtonsSlice} from './slices/gameActionButtonsSlice'
import {createGameCardAnimatorSlice, GameCardAnimatorSlice} from './slices/gameCardAnimatorSlice'
import {createGameCardInventorySlice, GameCardInventorySlice} from './slices/gameCardInventorySlice'
import {createGameMuteSlice, GameMuteSlice} from './slices/gameMuteSlice'

export type GameStoreType =
    GameGeneralSlice
    & GameStateSlice
    & GameUserStatesSlice
    & GameVoteSlice
    & GameTradeSlice
    & GameSettingsSlice
    & GameModeSlice
    & GameDetailsSlice
    & GameUserSettingsSlice
    & GameActionBoxSlice
    & GameReplaySlice
    & GameEndSlice
    & GameBeginnerHintSlice
    & GamePauseSlice
    & GameCardAnimatorSlice
    & GameActionButtonsSlice
    & GameCardInventorySlice
    & GameMuteSlice

export type GameStore = StoreApi<GameStoreType>

export interface GameStoreProps {
    gameGeneral: GameGeneralSliceProps
    gameState: GameStateSliceProps
    gameUserStates: GameUserStatesSliceProps
    gameVote: GameVoteSliceProps
    gameTrade: GameTradeSliceProps
    gameSettings: GameSettingsSliceProps
    gameMode: GameModeSliceProps
    gameDetails: GameDetailsSliceProps
    gameUserSettings: GameUserSettingsProps
    gamePause: GamePauseSliceProps
    gameReplay: GameReplaySliceProps
}

export const createGameStore = ({
    gameGeneral,
    gameState,
    gameUserStates,
    gameVote,
    gameTrade,
    gameSettings,
    gameMode,
    gameDetails,
    gameUserSettings,
    gamePause,
    gameReplay,
}: GameStoreProps) => createStore<GameStoreType>((set, get, api) => ({
    ...createGameGeneralSlice(gameGeneral)(set, get, api),
    ...createGameStateSlice(gameState)(set, get, api),
    ...createGameUserStatesSlice(gameUserStates)(set, get, api),
    ...createGameVoteSlice(gameVote)(set, get, api),
    ...createGameTradeSlice(gameTrade)(set, get, api),
    ...createGameSettingsSlice(gameSettings)(set, get, api),
    ...createGameModeSlice(gameMode)(set, get, api),
    ...createGameDetailsSlice(gameDetails)(set, get, api),
    ...createGameUserSettingsSlice(gameUserSettings)(set, get, api),
    ...createGameActionBoxSlice()(set, get, api),
    ...createGameReplaySlice(gameReplay)(set, get, api),
    ...createGameEndSlice()(set, get, api),
    ...createGameBeginnerHintSlice()(set, get, api),
    ...createGamePauseSlice(gamePause)(set, get, api),
    ...createGameCardAnimatorSlice()(set, get, api),
    ...createGameActionButtonsSlice(set, get, api),
    ...createGameCardInventorySlice()(set, get, api),
    ...createGameMuteSlice()(set, get, api),
}))
